<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
          <div class="row d-flex justify-content-end mr-0 mb-3">
            <div class="col-auto pr-0">
              <CButton v-if="permissions.employees.add" color="success" @click="createEmployee()">
                <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $tc('employees.label', 1) }}
              </CButton>
            </div>
          </div>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="perPage"
            :itemsPerPageSelect="itemsPerPage"
            :tableFilter="tableFilter"
            :table-filter-value.sync="search"
            :loading="loading"
            addTableClasses="d-print-table table-dropdown-fix"
            hover
            sorter
            pagination
          >
            <template #status="{item}">
              <td>
                <CBadge :color="item.status_class">{{ item.status ? $t('fields.active') : $t('fields.inactive') }}</CBadge>
              </td>
            </template>
            <template #options="{item}">
              <td>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                    {{ $t('button.options') }}
                  </button>
                  <div class="dropdown-menu">
                    <button v-if="permissions.employees.read" class="dropdown-item" type="button" @click="showEmployee(item.id)">{{ $t('button.details') }}</button>
                    <button v-if="permissions.employees.edit" class="dropdown-item" type="button" @click="editEmployee(item.id)">{{ $t('button.edit') }}</button>
                    <button v-if="permissions.employees.delete" class="dropdown-item" type="button" @click="deleteEmployee(item.id)">{{ $t('button.delete') }}</button>
                  </div>
                </div>
              </td>
            </template>
          </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPlus } from '@coreui/icons';

export default {
  name: 'Employees',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: i18n.t('fields.name') },
        { key: 'phone', label: i18n.t('fields.phone')}, 
        { key: 'personal_id', label: i18n.t('fields.personal_id') },
        { key: 'status', label: i18n.t('fields.status')},  
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      you: null,
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('clients.search_placeholder'),
        lazy: false,
        external: true
      },
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.getEmployees();
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    showEmployee(id) {
      this.$router.push({ name: 'Employee', params: {id} });
    },
    createEmployee () {
      this.$router.push({ name: 'CreateEmployee'});
    },
    editEmployee(id) {
      this.$router.push({ name: 'EditEmployee', params: {id} });
    },
    deleteEmployee(id) {
        let self = this;
      this.$swal({
        title: i18n.t('employees.modal.delete_label'),
        html: i18n.t('employees.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/employees/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
              self.getEmployees();
                self.$swal(
                  i18n.t('employees.modal.updated_label'),
                  i18n.t('employees.modal.updated_body'),
                  'success'
              );
          });
        }
      });
    },
    getEmployees() {
      this.loading = false;
      axios.get('/api/employees?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.items = response.data;
        this.items.forEach(elem => {
          elem.status_class = elem.status ? "primary" : "secondary";
        });
      }).catch(error => {
        this.loading = false;
        console.log(error);
        this.showAlertError();
      });
    }
  }
}
</script>

